/* 🤖 this file was generated by svg-to-ts */
export const DfIconClockArrow16: {
  name: 'clock-arrow-16';
  data: string;
} = {
  name: 'clock-arrow-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m9 7.589 1.71 1.715a1 1 0 1 1-1.415 1.414L7.293 8.709A.997.997 0 0 1 7 8.002v-3a1 1 0 1 1 2 0v2.587zm4.658-5.247 1.058-1.058a.5.5 0 0 1 .851.304l.378 3.878a.5.5 0 0 1-.542.547l-3.909-.347a.5.5 0 0 1-.309-.851l1.059-1.059a6 6 0 0 0-8.486.002A6 6 0 1 0 14 7.896l1.225.109A2.5 2.5 0 0 0 16 7.953a7.978 7.978 0 0 1-2.343 5.705A8 8 0 1 1 2.344 2.344a8 8 0 0 1 11.314-.002z"/></svg>`
};
